var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('mercadolibre-list',{attrs:{"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }